import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs } from "@fortawesome/pro-regular-svg-icons/faCogs";

export const defaultTranslations = {
    pluginName: "Departments",
    pluginDescription: "Show departments",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faCogs} size="3x" />,
};
